import { useState } from "react";
import { resolveUser } from "../services/api";

export function useResolveUser() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const resolve = async (phone, boothId) => {
		if (!phone || !boothId) {
			throw new Error("Phone number and booth ID are required");
		}

		setLoading(true);
		setError(null);

		try {
			const result = await resolveUser(phone, boothId);
			return result;
		} catch (err) {
			setError(err.message);
			throw err;
		} finally {
			setLoading(false);
		}
	};

	const clearError = () => setError(null);

	return {
		resolve,
		loading,
		error,
		clearError,
	};
}